import { motion } from "framer-motion";

const ManufacturerVendor = ({ features, scrollToForm }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 relative overflow-hidden">
      
      {/* Background blobs */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-indigo-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 space-y-12 relative z-10">

        {/* HERO */}
        <motion.section
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="flex flex-col items-center text-center space-y-6"
        >
          <div className="relative">
            <div className="absolute -inset-4 bg-blue-600 opacity-20 blur-lg rounded-full"></div>

            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight relative">
              Welcome to{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                DronePlanet
              </span>
              <br />
              <span className="text-xl md:text-2xl font-semibold text-gray-600 mt-3 block">
                Where Innovation Takes Flight!
              </span>
            </h1>
          </div>

          <p className="text-lg text-gray-700 max-w-2xl bg-white/70 backdrop-blur-sm p-5 rounded-2xl shadow-sm border border-white">
            Are you a Drone Manufacturer? Stop Waiting. Start Selling. Start Hiring.  
            Join the{" "}
            <span className="font-semibold text-blue-700">
              #1 Explosive Marketplace
            </span>{" "}
            for Drones, Parts & Talents.
          </p>

          {/* CTA */}
          {/* <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToForm}
            className="px-8 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold shadow-md"
          >
            Get Started
          </motion.button> */}
        </motion.section>

        {/* WHY REGISTER */}
        <section className="relative py-6">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
            Why Register on{" "}
            <span className="text-blue-600">DronePlanet</span>?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-0">
            {features?.map((card, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
                whileHover={{ y: -6 }}
                className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-white relative overflow-hidden group"
              >
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-indigo-500"></div>

                <div className="mb-5 w-14 h-14">
                  <img
                    src={card.icon}
                    alt={card.title}
                    className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                  />
                </div>

                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {card.title}
                </h3>

                <p className="text-gray-600 text-sm">{card.desc}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* WHO'S IT FOR */}
        <section>
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
            Who's It For?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              "Drone & UAV Manufacturers",
              "Drone Part & Component Makers",
              "Custom Drone Builders",
              "Startups in Drone Tech",
              "Aerospace Innovators",
              "Anyone Building the Future of Flight",
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                whileHover={{ y: -4, scale: 1.02 }}
                className="bg-white p-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-white/50 group"
              >
                <div className="flex items-center">
                  <div className="flex-shrink-0 w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                    ✓
                  </div>

                  <span className="text-gray-800 text-sm font-medium">
                    {item}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* CTA SECTION */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center space-y-6 py-8 bg-gradient-to-r from-blue-500/5 to-indigo-500/5 rounded-2xl backdrop-blur-sm border border-white/30"
        >
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              You're a manufacturer – you build the future. Let the world see it.
            </h2>

            <p className="text-gray-700 text-base mb-5">
              From cutting-edge drones to essential components, DronePlanet is
              where your products get the attention and orders they deserve.
            </p>

            <a
              href="https://wa.me/919773571992"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-3 px-6 rounded-full font-medium shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Contact Sales
            </a>
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default ManufacturerVendor;